import { render, staticRenderFns } from "./MediaLibraryItem.vue?vue&type=template&id=61926275&scoped=true&"
import script from "./MediaLibraryItem.vue?vue&type=script&lang=ts&"
export * from "./MediaLibraryItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaLibraryItem.vue?vue&type=style&index=0&id=61926275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61926275",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VIcon,VImg,VLayout})
